import gql from 'graphql-tag'

const QUERY_TIMESLOT_ORDER_LIMIT_STATS = gql`
  query timeslotOrderLimitStats(
    $storeId: ID!
    $fulfillmentDate: String!
    $fulfillmentType: FulfillmentType!
    $precalculatedOrderLimit: Int
  ) {
    timeslotOrderLimitStats(
      storeId: $storeId
      fulfillmentDate: $fulfillmentDate
      fulfillmentType: $fulfillmentType
      precalculatedOrderLimit: $precalculatedOrderLimit
    ) {
      fulfillmentDate
      fulfillmentTimeRange
      fulfillmentType
      orderLimit
      orderCount
    }
  }
`

export { QUERY_TIMESLOT_ORDER_LIMIT_STATS }
